/*
 * File: d:\projects\AutoFiFront\src\Content\CollapseBox\CollapseBox.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 18th 2023 3:41:12 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import translator from 'MultiLanguage/TranslationWrapper';
import React, { useCallback, useState } from 'react';
import { Collapse } from 'react-collapse';
import styles from 'Content/CollapseBox/CollapseBox.module.css';
import { IoIosArrowDropdownCircle } from 'react-icons/io';

type CollapseBoxProps = {
    question: string,
    response: string[],
};

function CollapseBox(props: CollapseBoxProps) {
    const [isButtonCollapseOpen, setIsButtonCollapseOpen] = useState(false);
    const onClick = useCallback(
        () => setIsButtonCollapseOpen(!isButtonCollapseOpen),
        [isButtonCollapseOpen]
    );
    return (
        <React.Fragment>
            <div className={`${styles.question}`}>
                <button className={`${styles.questionButton}`} onClick={onClick}>
                    <div className={`${styles.questionText}`}>
                        {translator.decode(`faq.${props.question}`)}
                    </div>
                    <IoIosArrowDropdownCircle fill='var(--theme-color)'/>
                </button>
            </div>
            <Collapse isOpened={isButtonCollapseOpen}>
                {
                    props.response.map((item,index) => { return <div key={item+index} className={`${styles.response}`}> {translator.decode(`faq.${item}`)}</div> })
                }
            </Collapse>
        </React.Fragment>
    )
}

export default CollapseBox;
